import RelayIcon from '@/components/RelayIcon'
import { useFetchRelayInfo } from '@/hooks/useFetchRelayInfo'
import { toRelay } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { cn } from '@/lib/utils'

export default function RelayCard({
  url,
  children,
  className
}: {
  url: string
  children?: React.ReactNode
  className?: string
}) {
  const { relayInfo } = useFetchRelayInfo(url)

  return (
    <SecondaryPageLink
      to={toRelay(url)}
      className={cn('flex items-center gap-2 px-3 py-2', className)}
    >
      <RelayIcon url={url} className="w-8 h-8 shrink-0" iconSize={16} />
      <div className="flex-1 w-0 truncate">
        <div className="truncate text-sm font-medium">
          {relayInfo?.name || relayInfo?.urlSimple}
        </div>
        {relayInfo?.name && (
          <div className="truncate text-xs text-muted-foreground">{relayInfo.urlSimple}</div>
        )}
      </div>
      {children}
    </SecondaryPageLink>
  )
}
